import axios from 'axios'
import { API_ENDPOINT_BASE, ROOT } from '@/constans'
import { stringify } from 'qs'
import { LOADING, HOST, LOGED, EMAIL, AGENCY, NAME, ID } from '../mutations'
import swal from 'sweetalert2'
import { set } from '@/utils'

export default {
  namespaced: true,
  state: {
    host: null,
    loged: null,
    email: null,
    agency: {},
    name: null,
    id: null
  },
  mutations: {
    [HOST]: set('host'),
    [LOGED]: set('loged'),
    [EMAIL]: set('email'),
    [AGENCY]: set('agency'),
    [NAME]: set('name'),
    [ID]: set('id')
  },
  actions: {
    LOAD ({ commit }) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        axios.get(API_ENDPOINT_BASE)
          .then(({ data }) => {
            commit(LOGED, data.loged)
            commit(EMAIL, data.email)
            commit(AGENCY, data.agency)
            commit(NAME, data.name)
            commit(ID, data.id)
            data.host && commit(HOST, data.host)
            resolve()
          })
          .catch(error => {
            commit(LOGED, null)
            commit(EMAIL, null)
            commit(AGENCY, {})
            commit(NAME, null)
            commit(ID, null)
            commit(HOST, null)
            reject(error)
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    LOGIN ({ commit }, payload) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        axios.post(API_ENDPOINT_BASE + '/login', stringify(payload))
          .then(({ data }) => {
            swal({ html: 'Bienvenido', type: 'success' })
            commit(LOGED, data.loged)
            commit(EMAIL, data.email)
            commit(AGENCY, data.agency)
            commit(NAME, data.name)
            commit(ID, data.id)
            data.host && commit(HOST, data.host)
            resolve()
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            commit(LOGED, null)
            commit(EMAIL, null)
            commit(AGENCY, {})
            commit(NAME, null)
            commit(ID, null)
            reject(error)
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    HOST ({ commit }) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        axios.get(API_ENDPOINT_BASE + '/agencies')
          .then(response => {
            commit(LOADING, false, ROOT)
            swal({
              type: 'info',
              title: 'GESTIONAR AGENCIA',
              input: 'select',
              inputOptions: response.data,
              inputPlaceholder: 'SELECCIONAR ...',
              confirmButtonText: 'CAMBIAR',
              showCancelButton: true,
              cancelButtonText: 'CANCELAR'
            })
              .then(data => {
                data.value && axios.post(API_ENDPOINT_BASE + '/agencies/host', stringify(data))
                  .then(({ data }) => {
                    commit(AGENCY, data.agency)
                    swal({ html: data.msg, type: 'success', onClose: () => window.location.reload() })
                  })
                  .catch(error => {
                    commit(AGENCY, null)
                    reject(error)
                  })
                  .finally(() => commit(LOADING, false, ROOT))
              })
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            reject(error)
          })
      })
    },
    LOGOUT ({ commit }, data) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        axios.post(API_ENDPOINT_BASE + '/logout', stringify(data))
          .then(() => {
            commit(LOGED, null)
            commit(EMAIL, null)
            commit(AGENCY, {})
            commit(NAME, null)
            commit(ID, null)
            resolve()
            window.location.reload()
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            reject(error)
          })
      })
    }
  }
}
